import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../lib/utilities';
import { Price } from './price';
import Translation from '../../translation/translation';

const getLabel = labelKey => (
    <Translation
        translationKey={labelKey}
    />
);

export const TotalPrice = props => (
    <Price
        name={props.name}
        label={getLabel(!props.hasFitting ? props.labelKey : 'pdp-sidebar-fitted-total-label')}
        price={props.totalPrice}
        currencyIsoCode={props.currencyIsoCode}
        hasBorder={props.hasBorder}
        loading={props.loading}
        labelExtraChildren={props.labelExtraChildren}
        overrides={props.currencySetupOverrides}
        onLabelClick={props.onLabelClick}
        isTotalPrice={true}
        middle={false}
        colspan={2}
    />
);

TotalPrice.propTypes = {
    totalPrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    hasBorder: PropTypes.bool,
    name: PropTypes.string,
    labelExtraChildren: PropTypes.arrayOf(PropTypes.object),
    labelKey: PropTypes.string,
    currencySetupOverrides: PropTypes.object,
    onLabelClick: PropTypes.func,
};

TotalPrice.defaultProps = {
    hasBorder: true,
    name: 'total-price',
    labelKey: 'pdp-sidebar-total-price',
    currencySetupOverrides: {},
    onLabelClick: noop,
};
